import React, {useState} from 'react';
import {errorMessage} from '../../api/orders';
import '../ProductReviews.css';

export default function ProductReviewForm({review, onSave, onCancel}) {
    const [rating,setRating] = useState(review.rating || 0);
    const [title,setTitle] = useState(review.title || '');
    const [body,setBody] = useState(review.body || '');
    const [busy,setBusy] = useState(false);
    const [error,setError] = useState('');
    async function submit(event) {
        event.preventDefault(); setError(''); setBusy(true);
        try {await onSave({product_id:review.product_id, rating, title:title.trim(), body:body.trim()});}
        catch(err) {setError(errorMessage(err));} finally {setBusy(false);}
    }
    return <form className="nw-review-form" onSubmit={submit} aria-label={`Review ${review.product_name}`}>
        <h2>{review.reviewId ? 'Edit your review' : 'Write a review'}</h2><p>{review.product_name}</p>
        <p className="nw-review-note">Share your experience with the product. Reviews and edits may take a little time to appear.</p>
        {error && <p role="alert">{error}</p>}
        <fieldset disabled={busy}><legend>Your rating</legend><div className="nw-review-stars-input">{[1,2,3,4,5].map(star => <label key={star} data-selected={star<=rating}>
            <input type="radio" name="rating" value={star} checked={rating===star} required aria-label={`${star} star${star===1?'':'s'}`} onChange={()=>setRating(star)}/><span aria-hidden="true">★</span>
        </label>)}</div></fieldset>
        <label>Title <span className="nw-review-note">(optional)</span><input value={title} onChange={event=>setTitle(event.target.value)} maxLength={120} disabled={busy}/></label>
        <label>Your review<textarea value={body} onChange={event=>setBody(event.target.value)} required minLength={20} maxLength={2000} rows={4} disabled={busy}/></label>
        <span className="nw-review-note">20–2,000 characters · {body.length}/2,000</span>
        <div className="nw-review-form__actions"><button className="nw-account__button" disabled={busy || !rating || body.trim().length<20} type="submit">{busy?'Submitting…':'Submit'}</button><button type="button" className="nw-account__button nw-account__button--secondary" disabled={busy} onClick={onCancel}>Cancel</button></div>
    </form>;
}
